import { translate } from "./translator"

export let individualFeatures = [
    {
        src: "./IndividualFeatureImages/Group1A1.png",
        alt: "Group1A1",
        title: translate("Group1A1"),
    },
    {
        src: "./IndividualFeatureImages/Group1A2.png",
        alt: "Group1A2",
        title: translate("Group1A2"),
    },
    {
        src: "./IndividualFeatureImages/Group1B1.png",
        alt: "Group1B1",
        title: translate("Group1B1"),
    },
    {
        src: "./IndividualFeatureImages/Group1B2.png",
        alt: "Group1B2",
        title: translate("Group1B2"),
    },
    {
        src: "./FeatureGroupImages/Group1C.png",
        alt: "Group1C",
        title: translate("Group1C"),
    },
    {
        src: "./IndividualFeatureImages/Group2A1.png",
        alt: "Group2A1",
        title: translate("Group2A1"),
    },
    {
        src: "./IndividualFeatureImages/Group2A2.png",
        alt: "Group2A2",
        title: translate("Group2A2"),
    },
    {
        src: "./FeatureGroupImages/Group3.png",
        alt: "Group3",
        title: translate("Group3"),
    },
    {
        src: "./FeatureGroupImages/Group4.png",
        alt: "Group4",
        title: translate("Group4"),
    },
    {
        src: "./FeatureGroupImages/Group5.png",
        alt: "Group5",
        title: translate("Group5"),
    },
    {
        src: "./FeatureGroupImages/Group6.png",
        alt: "Group6",
        title: translate("Group6"),
    },
    {
        src: "./IndividualFeatureImages/Group7A.png",
        alt: "Group7A",
        title: translate("Group7A"),
    },
    {
        src: "./IndividualFeatureImages/Group7B.png",
        alt: "Group7B",
        title: translate("Group7B"),
    },
    {
        src: "./IndividualFeatureImages/Group7C.png",
        alt: "Group7C",
        title: translate("Group7C"),
    },
    {
        src: "./FeatureGroupImages/Group8.png",
        alt: "Group8",
        title: translate("Group8"),
    },
    {
        src: "./FeatureGroupImages/Group9.png",
        alt: "Group9",
        title: translate("Group9"),
    },
    {
        src: "./FeatureGroupImages/Group10.png",
        alt: "Group10",
        title: translate("Group10"),
    },
    {
        src: "./FeatureGroupImages/Group11.png",
        alt: "Group11",
        title: translate("Group11"),
    },
    {
        src: "./IndividualFeatureImages/Group12A.png",
        alt: "Group12A",
        title: translate("Group12A"),
    },
    {
        src: "./IndividualFeatureImages/Group12B.png",
        alt: "Group12B",
        title: translate("Group12B"),
    },
    {
        src: "./FeatureGroupImages/Group13.png",
        alt: "Group13",
        title: translate("Group13"),
    },
    {
        src: "./FeatureGroupImages/Group14.png",
        alt: "Group14",
        title: translate("Group14"),
    },
    {
        src: "./FeatureGroupImages/Group15.png",
        alt: "Group15",
        title: translate("Group15"),
    },
    {
        src: "./FeatureGroupImages/Group16.png",
        alt: "Group16",
        title: translate("Group16"),
    },
    {
        src: "./FeatureGroupImages/Group17.png",
        alt: "Group17",
        title: translate("Group17"),
    },
    {
        src: "./FeatureGroupImages/GroupS1.png",
        alt: "GroupS1",
        title: translate("GroupS1"),
    },
    {
        src: "./FeatureGroupImages/GroupS2.png",
        alt: "GroupS2",
        title: translate("GroupS2"),
    },
    {
        src: "./FeatureGroupImages/GroupS3.png",
        alt: "GroupS3",
        title: translate("GroupS3"),
    },
    {
        src: "./FeatureGroupImages/GroupS4.png",
        alt: "GroupS4",
        title: translate("GroupS4"),
    },
]